<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-profit-model-alt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 33a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2v-8a2 2 0 012-2h7zm27-13a2 2 0 012 2v21a2 2 0 01-2 2h-7a2 2 0 01-2-2V22a2 2 0 012-2h7zm-13.5 7a2 2 0 012 2v14a2 2 0 01-2 2h-7a2 2 0 01-2-2V29a2 2 0 012-2h7zM11 37H8v4h3v-4zm27-13h-3v17h3V24zm-13.5 7h-3v10h3V31zm7.923-24.908l.117.003 9.278.812a1 1 0 01.647 1.676l-.092.086-18.067 15.16a1 1 0 01-1.329-.037l-.08-.085-3.857-4.597L6.783 29.395a1 1 0 01-1.408-.123L4.089 27.74a1 1 0 01.123-1.41l15.321-12.855a1 1 0 011.409.123l3.857 4.597 9.192-7.714-2.305-2.747a1 1 0 01-.233-.598l.003-.132a1 1 0 01.967-.912z"/></svg>
</template>
<script>

export default {
  name: 'IconProfitModelAlt',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
